import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import MagicLinkCallback from "@/components/MagicLinkCallback";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Synchronous route detection for the one-time email magic-link landing.
function pickRootComponent() {
  if (typeof window === "undefined") return <App />;
  const path = window.location.pathname;
  if (path === "/auth/magic") return <MagicLinkCallback />;
  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {pickRootComponent()}
    </QueryClientProvider>
  </React.StrictMode>,
);
